<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [style]="{ width: '560px', maxHeight: '90vh' }" header="Update Software" (onHide)="reset()">
    <div class="deploy-version-dialog">
        <div class="deploy-summary">
            <div>
                <span class="summary-label">Device</span>
                <span class="summary-value">{{ deviceName() }}</span>
            </div>
            <div>
                <span class="summary-label">Current version</span>
                <span class="summary-value">{{ currentVersion() || '—' }}</span>
            </div>
        </div>

        <div class="form-field">
            <div class="field-header">
                <label class="form-label" for="deployVersionSelect">Version to deploy</label>
                <button pButton type="button" class="p-button-text p-button-sm" (click)="selectLatest()" [disabled]="loading() || !latestVersion()"><i class="pi pi-arrow-up p-button-icon" aria-hidden="true"></i><span class="p-button-label">Use latest</span></button>
            </div>
            <p-select
                inputId="deployVersionSelect"
                [options]="versions()"
                optionLabel="label"
                optionValue="value"
                [ngModel]="selectedKey()"
                (ngModelChange)="selectedKey.set($event)"
                placeholder="Select a version..."
                [loading]="loading()"
                [filter]="true"
                filterPlaceholder="Search versions..."
                [virtualScroll]="versions().length > 100"
                [virtualScrollItemSize]="40"
                appendTo="body"
                class="w-full">
                <ng-template #selectedItem let-item>
                    <div class="version-option" *ngIf="item">
                        <span>{{ item.label }}</span>
                        <p-tag *ngIf="item.isLatest" value="Latest" severity="success" class="ml-2"></p-tag>
                        <p-tag *ngIf="item.isDebugBuild" value="Debug" severity="warn" class="ml-1"></p-tag>
                    </div>
                </ng-template>
                <ng-template #item let-item>
                    <div class="version-option">
                        <span>{{ item.label }}</span>
                        <p-tag *ngIf="item.isLatest" value="Latest" severity="success" class="ml-2"></p-tag>
                        <p-tag *ngIf="item.isDebugBuild" value="Debug" severity="warn" class="ml-1"></p-tag>
                        <p-tag *ngIf="!item.isDebugBuild" value="Release" severity="info" class="ml-1"></p-tag>
                    </div>
                </ng-template>
            </p-select>
            <small *ngIf="loadError()" class="text-error">{{ loadError() }}</small>
            <small *ngIf="!loading() && !loadError() && versions().length === 0" class="text-muted">
                No packages are available for this device.
                <ng-container *ngIf="devicePackageNamespace()"> Only packages matching its application namespace (<code>{{ devicePackageNamespace() }}</code>) are listed. </ng-container>
            </small>
        </div>

        <div class="release-notes" *ngIf="selectedVersion() as version">
            <div class="release-notes-meta">
                <span *ngIf="selectedUploadedLabel()">Uploaded {{ selectedUploadedLabel() }}</span>
                <span *ngIf="version.uploadedBy">by {{ version.uploadedBy }}</span>
            </div>
            <p *ngIf="version.releaseNotes; else noNotes" class="release-notes-body">{{ version.releaseNotes }}</p>
            <ng-template #noNotes>
                <p class="release-notes-body text-muted">No release notes for this version.</p>
            </ng-template>
        </div>

        <div class="selection-notice" *ngIf="selectionNotice() as notice" [class.warn]="notice.severity === 'warn'">
            <i class="pi" [ngClass]="notice.severity === 'warn' ? 'pi-exclamation-triangle' : 'pi-info-circle'"></i>
            <span>{{ notice.text }}</span>
        </div>

        <div class="form-field">
            <label class="checkbox-label">
                <p-checkbox [binary]="true" [ngModel]="scheduleEnabled()" (ngModelChange)="onScheduleToggle($event)"></p-checkbox>
                <span>Schedule for later</span>
            </label>
            <small *ngIf="!scheduleEnabled()" class="text-muted">The update is dispatched as soon as the device checks in.</small>
            <p-datepicker
                *ngIf="scheduleEnabled()"
                [ngModel]="scheduledFor()"
                (ngModelChange)="scheduledFor.set($event)"
                [showTime]="true"
                hourFormat="24"
                [stepMinute]="5"
                [minDate]="minScheduleDate"
                appendTo="body"
                class="w-full"></p-datepicker>
            <small *ngIf="scheduleError()" class="text-error">{{ scheduleError() }}</small>
        </div>

        <div *ngIf="submitError()" class="text-error">{{ submitError() }}</div>
    </div>

    <ng-template #footer>
        <button pButton type="button" class="p-button-text" (click)="visible.set(false)" [disabled]="submitting()"><span class="p-button-label">Cancel</span></button>
        <button pButton type="button" (click)="deploy()" [disabled]="!canSubmit()"><i class="pi pi-cloud-upload p-button-icon" aria-hidden="true"></i><span class="p-button-label">{{ scheduleEnabled() ? 'Schedule Update' : 'Deploy' }}</span></button>
    </ng-template>
</p-dialog>
